<template>
    <section class="header-guide-container">
        <div class="header-guide">
            <!-- eslint-disable vue/no-v-html -->
            <div
                class="header-guide__title"
                v-html="pageHeader.title"
            ></div>

            <!-- eslint-disable vue/no-v-html -->
            <div
                v-if="pageHeader.subtitle"
                class="header-guide__subtitle"
                v-html="pageHeader.subtitle"
            ></div>

            <ProductGuide
                v-if="pageHeader.product_guide"
                :product-guide="pageHeader.product_guide"
            />
        </div>
    </section>
</template>

<script setup>
import ProductGuide from '../../header-components/product-guide/watson-theme-product-guide.vue';

defineProps({
    pageHeader: {
        type: Object,
        required: false,
        default: null,
    },
});
</script>

<style lang="scss" scoped>
@use "watson-theme-header-guide";
</style>
